function hideAnnounce () {
    let closeButton = document.querySelector(".announcement-bar__close");
    let announcementBar = document.querySelector('.announcement-bar-section');
  
    let hours = 24; 
    let now = new Date().getTime();
    let setupTime = localStorage.getItem('setupTime');
    
    
    if (localStorage.getItem("announcementBar") === "none") {
        announcementBar.style.display = "none";
        let checkMethod = true;
        setInterval(() => {
          if( document.querySelector('.section-header') && checkMethod ) {
            checkMethod = false;
            document.querySelector('.section-header').classList.add('moved-top');
          }
        }, "100");
    }
  
    if (setupTime == null) {
      localStorage.setItem('setupTime', now)
    } else {
        if(now-setupTime > hours*60*60*1000) {
            localStorage.clear()
            localStorage.setItem('setupTime', now);
        }
    }
  
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        announcementBar.style.display = 'none';
        localStorage.setItem("announcementBar", "none");
        document.querySelector('.section-header').classList.add('moved-top');
        localStorage.setItem('setupTime', now);
      });
    }
}

hideAnnounce ();